import { getNewAuthToken, isTokenExpired } from "../utils";
import axios from "../utils/axios";
import setAuthToken from "../utils/setAuthToken";
import { baseURL } from "../utils/url";

export const Token_Generator = async () => {
    try {
        const fetchResponse = await fetch(baseURL + "tokengenerator", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const Internal_Token = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "internaltoken", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const signin = async (token, data) => {
    try {
        const fetchResponse = await fetch(baseURL + "signin", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const response = await fetchResponse.json();
        return response;
    } catch (error) {
        return error;
    }
};

export const Signin = async (body) => {
    
    try {
       
        const fetchResponse = await fetch(baseURL + "Login", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
  };
  export const signup = async (body) => {
    
    try {
       
        const fetchResponse = await fetch(baseURL + "Signup", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
  };

  export const confirmEmail = async (body) => {
    
    try {
       
        const fetchResponse = await fetch(baseURL + "ConfirmEmail", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
  };
  
  export const postBulkMail = async (body) => {
    
    try {
       
        const fetchResponse = await fetch(baseURL + "PostBulkMail", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
  };
  export const senderEmail = async (body) => {
    
    try {
       
        const fetchResponse = await fetch(baseURL + "PostSenderEmail", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
  };
  export const createDomain = async (body) => {
    
    try {
       
        const fetchResponse = await fetch(baseURL + "PostSenderDomainData", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
  };
  
  export const getEmailHistory = async (userId) => {
    try {
      const fetchResponse = await fetch(baseURL + `GetEmailHistory?userId=${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const response = await fetchResponse.json();
      return response;
    } catch (error) {
      return error;
    }
  };
  export const getSenderEmail = async (userId) => {
    try {
      const fetchResponse = await fetch(baseURL + `GetSenderEmail?userId=${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const response = await fetchResponse.json();
      return response;
    } catch (error) {
      return error;
    }
  };
  export const getDomain = async (userId) => {
    try {
      const fetchResponse = await fetch(baseURL + `GetSenderDomainData?userId=${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const response = await fetchResponse.json();
      return response;
    } catch (error) {
      return error;
    }
  };

export const forgetPassword = async (token, data) => {
    try {
        const fetchResponse = await fetch(baseURL + "forget", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            auth: (token, { type: "bearer" }),
            body: JSON.stringify(data),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const resetPassword = async (token, data) => {
    try {
        const fetchResponse = await fetch(baseURL + "reset", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            auth: (token, { type: "bearer" }),
            body: JSON.stringify(data),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};